var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateSlot",
    {
      class: _vm.context.classes.grouping,
      attrs: {
        name: "grouping",
        context: _vm.context,
        "force-wrap": _vm.context.repeatable
      }
    },
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "FormulateRepeatableProvider",
        {
          key: item.__id,
          attrs: {
            index: index,
            context: _vm.context,
            uuid: item.__id,
            errors: _vm.groupErrors[index]
          },
          on: {
            remove: _vm.removeItem,
            input: function(values) {
              return _vm.setItem(index, values)
            }
          }
        },
        [_vm._t("default")],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }